import React from "react";
import { answeredFollowUp, exampleTipKey, firstAnswerTipKey, needsExampleTip } from "@/lib/followUps";

// The follow-up and the candidate's answer to it, shown under the main answer in
// the report: one exchange, scored together (FOLLOW_UP_PLAN.md §9, P1).
export function FollowUpExchange({ answer, t, testId }) {
  const followUp = answeredFollowUp(answer);
  if (!followUp) return null;
  return (
    <div className="mt-6 rounded-2xl border-l-4 border-[color:var(--brand)] bg-[color:var(--bg-surface-hover)] p-5" data-testid={testId}>
      <div className="text-xs uppercase tracking-widest text-[color:var(--brand)]">{t("rp.followUp")}</div>
      <p className="mt-2 font-semibold leading-snug">{followUp.text}</p>
      <div className="mt-4 text-xs uppercase tracking-widest text-[color:var(--text-secondary)]">{t("rp.followUpAnswer")}</div>
      <p className="mt-2 text-sm leading-relaxed">{followUp.transcript}</p>
      {/* Step 5: what to put in the first answer next time (the F9 tip below covers a still-missing example). */}
      {firstAnswerTipKey(answer) && !needsExampleTip(answer) && (
        <div className="mt-4 rounded-xl bg-[color:var(--brand)]/5 border border-[color:var(--brand)]/20 p-4 text-sm" data-testid={testId ? `${testId}-first-tip` : undefined}>
          <span className="font-semibold">{t("rp.tip")}: </span>
          {t(firstAnswerTipKey(answer))}
        </div>
      )}
      {needsExampleTip(answer) && (
        <div className="mt-4 rounded-xl bg-[color:var(--brand)]/5 border border-[color:var(--brand)]/20 p-4 text-sm" data-testid={testId ? `${testId}-tip` : undefined}>
          <span className="font-semibold">{t("rp.tip")}: </span>
          {t(exampleTipKey(answer))}
        </div>
      )}
    </div>
  );
}
